export default __webpack_public_path__ + "static/media/38.b21d4319.png";